<template>
	<div class="clearfix rounded mx-auto">

        <h4>Set Additional Features</h4>

		<div class="row px-3">
			<form @submit.stop.prevent="submitSettings" class="w-100">
                <fieldset>
                    <div id="settings">
                        <div class="clearfix rounded ibox-content px-0 pb-0">
                            <div class="clearfix row no-margin">
                                <div class="col-md-12 fixed-section-one px-0 mb-4">
                                    <div class="clearfix approval-container row bg-white mt-0">
                                        <div class="col-12 approve-level-content">
                                            <table class="table table-sm first-child-no-border">
                                                <thead>
                                                    <tr class="align-middle">
                                                        <td>Feature Name</td>
                                                        <td class="text-right">Status</td>
                                                        <td class="text-right">Updated At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr
                                                        v-for="(setting, index) in company_access_settings"
                                                        :key="setting.module_key"
                                                        class="align-middle"
                                                    >
                                                        <td
                                                            class="col-md-3 pl-0 py-2 salary-heads"
                                                            :class="{ 'inactive-head': !setting.value }"
                                                        >
                                                            {{ setting.title }}
                                                        </td>

                                                        <td class="col-md-3 text-right pr-0 py-2">
                                                            <toggle-button
                                                                v-model="setting.value"
                                                                :color="{
                                                                    checked: '#01524B',
                                                                    unchecked: '#CC5057',
                                                                    disabled: '#8F8F8F'
                                                                }"
                                                            />
                                                        </td>
                                                        <td class="col-md-3 text-right pr-0 py-2">
                                                            {{ setting.updated_at }}
                                                        </td>
                                                    </tr>

                                                    <tr v-if="company_access_settings.length === 0">
                                                        <td colspan="3" class="text-center py-3">
                                                            No feature settings found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
			</form>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
            company_access_settings: [],
        };
    },

    methods: {
        submitSettings() {
            const settings = this.company_access_settings.map(item => ({
                title: item.title,
                module_key: item.module_key,
                value: item.value ? 1 : 0,
            }));

            const formData = new FormData();
            formData.append('access_settings', JSON.stringify(settings));

            return axios.post(this.$api_url + '/leave-attendance/module/settings', formData);
        },

        get_access_settings() {
            if (!this.checkNet()) return false;

            axios.get(this.$api_url + '/leave-attendance/module/settings')
                .then(response => {
                    this.company_access_settings = response.data.map(item => ({
                        title: item.title,
                        module_key: item.module_key,
                        value: item.value == 1,
                        updated_at: item.updated_at,
                    }));
                })
                .catch(error => {
                    this.serverError ? this.serverError(error) : console.log(error);
                });
        },
    },

    created() {
        this.get_access_settings();
    }
};
</script>
